import { Amplify } from 'aws-amplify'

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.VUE_APP_USER_POOL_ID,
      userPoolClientId: process.env.VUE_APP_CLIENT_ID,
      region: process.env.VUE_APP_REGION,
    }
  }
}

Amplify.configure(amplifyConfig)

export default amplifyConfig
